module.exports = __webpack_public_path__ + "static/assets/c64a01c5c86f1b21612829237cbf4e08.svg";